import { inject, Pipe, PipeTransform } from '@angular/core';
import { IDisplayInfoField } from '@pkp-g/shared';
import { LocalizationPipe } from '@shared/modules/localization';

@Pipe({
  name: 'displayInfoField',
  standalone: true,
})
export class DisplayInfoFieldPipe implements PipeTransform {
  private readonly localization = inject(LocalizationPipe);
  transform(field: IDisplayInfoField): string {
    if (this.isEmpty(field.value)) {
      return field.fallback || this.localization.transform('ADMIN_USERS_LABEL_NOT_SPECIFIED');
    }

    return String(field.value);
  }

  private isEmpty(value: unknown): boolean {
    return (
      value === null ||
      value === '' ||
      value === false ||
      (Array.isArray(value) && value.length === 0)
    );
  }
}
